import { useState, useEffect, useRef } from 'react';
// import useAuth from './hooks/useAuth';
import { useAuth } from './context/AuthProvider';
import VideoPlayer from './VideoPlayer';
import parte_1_thumb from '../images/thumbs/parte_1_thumb.png'
import parte_2_thumb from '../images/thumbs/parte_2_thumb.png'
import parte_3_thumb from '../images/thumbs/parte_3_thumb.png'
import parte_4_thumb from '../images/thumbs/parte_4_thumb.png'
import parte_5_thumb from '../images/thumbs/parte_5_thumb.png'
import parte_6_thumb from '../images/thumbs/parte_6_thumb.png'
import parte_7_thumb from '../images/thumbs/parte_7_thumb.png'
import parte_8_thumb from '../images/thumbs/parte_8_thumb.png'
import LockIcon from '@mui/icons-material/Lock';
import { isSafari } from 'react-device-detect'
import {db, storage} from './firebase'
import {collection, getDocs} from 'firebase/firestore'
import {getDownloadURL, ref} from 'firebase/storage'
import axios from 'axios';
import { BASE_URL } from './utils/Scripts'
import { useIsMobile } from './context/MobileContext';
import SkeletonBackground from './utils/SkeletonBackground';

export function VideoThumb(props:any){
    const [thumb, setThumb] = useState('')

    const isMobile = useIsMobile()

    async function getThumb(){
        const new_thumb = await getDownloadURL(ref(storage,'thumbs/'+props.thumb))
        setThumb(new_thumb)
    }
    useEffect(()=>{
        getThumb()
    },[])
    return(
        <div style={{float:'left', width:80*16/9, height:'80px', marginTop:'10px', backgroundImage:`url('${thumb}')`, backgroundSize:'cover'}}>
            {!props.isAllowed&&(
            <div style={{backgroundColor:"rgba(0,0,0,0.6)", height:'100%', width:'100%'}}>
                <div style={{color:"#fff", position:'relative', top:'50%', transform:'translateY(-50%)'}}>
                    <LockIcon style={{transform:'scale(1.3)'}}/>
                </div>
            </div>
            )}
        </div>
    )
}

export function SelectedVideo(props:any){
    const video = props.video
    const [currentId, setCurrentId] = useState(video.parts[0].id)
    const [thumb, setThumb] = useState('')
    async function getThumb(){
        const new_thumb = await getDownloadURL(ref(storage,'thumbs/'+video.main_thumb))
        setThumb(new_thumb)
    }
    useEffect(()=>{
        getThumb()
    },[])

    const {user} = useAuth()
    const isMobile = useIsMobile()

    function isAllowed(){
        let allowed = false
        if(user?.roles.includes(1)){
            allowed = true
        }
        return(allowed)
    }

    const HLS_URL =(id:any)=> 'https://vz-93c1c9db-985.b-cdn.net/'+id+'/playlist.m3u8'
    

    function videoJsOptions(id:string) {
        return(
            {            autoplay: false,
            controls: true,
            responsive: true,
            fluid: true,
            playbackRates: [1, 1.5, 2],
            sources: [{
                src: HLS_URL(id),
                type: 'application/x-mpegURL'
            }]}
        )
    }

    return(
        <div style={{display:'flex', flexDirection:isMobile?'column':'row', width:'100%'}}>
            <div style={{overflow:'hidden', borderRadius:isMobile?'0px':'10px', left:'0'}}>
                {isAllowed()
                ?
                <VideoPlayer options={videoJsOptions(currentId)} width={isMobile?'100%':'60vw'}/>
                // <iframe style={{border:'none'}} width={isMobile?props.width:props.width*0.6} height={isMobile?props.width*9/16:props.width*0.6*9/16} src={"https://www.youtube.com/embed/"+currentId} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                :
                <div style={{width:isMobile?'100vw':'60vw', height:isMobile?(props.width)/16*9:(props.width*0.6)/16*9, backgroundImage:'url('+thumb+')', backgroundSize:'cover'}}></div>
                }
                
            </div>
            <div style={{height:isMobile?'':(props.width*0.6)/16*9, width:isMobile?'80vw':'20vw', marginLeft:isMobile?'0px':'50px', overflowY:isMobile?'hidden':'scroll', marginTop:isMobile?'10px':''}}>
                {video.parts.map((part:any, key:any)=>{
                        return(
                            <div key={key} style={{
                                color:"#fff",
                                cursor:'pointer',
                                height:'100px',
                                display:'flex',
                                alignItems:'center',
                                border: currentId===part.id?'1px solid #927a02':'1px solid transparent',
                                borderRadius:'5px'
                            }} onClick={()=>{setCurrentId(part.id)}}>
                                {/* <div style={{float:'left', width:80*16/9, height:'80px', marginTop:'10px', backgroundImage:`url('${''}')`, backgroundSize:'cover'}}>
                                    {!isAllowed()&&(
                                    <div style={{backgroundColor:"rgba(0,0,0,0.6)", height:'100%', width:'100%'}}>
                                        <div style={{color:"#fff", position:'relative', top:'50%', transform:'translateY(-50%)'}}>
                                            <LockIcon style={{transform:'scale(1.3)'}}/>
                                        </div>
                                    </div>
                                    )}
                                </div> */}
                                <VideoThumb isAllowed={isAllowed()} thumb={part.thumb}/>
                                <div style={{position:'relative', marginLeft:'10px'}}>
                                    Parte {key+1} de {video.parts.length}
                                </div>
                            </div>
                        )
                })}
            </div>
            <div style={{clear:'both'}}/>
        </div>
    )
}

export function MainVideoThumb(props:any){

    const [thumb, setThumb] = useState('')
    async function getThumb(){
        const new_thumb = await getDownloadURL(ref(storage,'thumbs/'+props.thumb))
        setThumb(new_thumb)
    }
    useEffect(()=>{
        getThumb()
    },[])

    const isMobile = useIsMobile()

    const wid = isMobile?0.8*props.width:350
    
    return(
        <SkeletonBackground style={{width:wid+'px',height:wid*9/16+'px', borderRadius:'8px', overflow:'hidden'}} image={thumb}/>
        // <div style={{width:wid+'px',height:wid*9/16+'px', backgroundImage:`url('${thumb}')`, backgroundSize:'cover', borderRadius:'8px'}}/>
    )
}

export function PlaylistVideo(props:any){
    const [videos, setVideos] = useState<any>([])
    const [selected, setSelected] = useState({})
    const isMobile = useIsMobile()

    async function getVideos(){
        const options ={
            url:BASE_URL+'arcalab_firestore',
            method:'POST',
            headers: {
                accept: 'application/json',
                'content-type': 'application/json',
            },
            data:{
                type:'getDocs',
                collection:'arcalab_videos'
            }
        }
        const snapshot:any = await axios(options)
        let videos_var:any = []
        let index = 0
        snapshot.data.map(async(doc:any)=>{
            index++
            const title = doc.data.title
            const date = doc.data.date
            const main_thumb = doc.data.main_thumb
            const description = doc.data.description
            const subjects = doc.data.subjects
            const dateStringToTimestamp = (dateString:any) =>{
                const [day, month, year] = dateString.split('/').map(Number)
                const date = new Date(year, month-1, day)
                return(date.getTime())
            }
            const timestamp = dateStringToTimestamp(date)
            const duration = doc.data.duration
            let parts = []
            for(let a=0;a<doc.data.videos.length;a++){
                // const thumb = await getDownloadURL(ref(storage, 'thumbs/'+doc.data().videos[a].thumb))
                parts.push({
                        id:doc.data.videos[a].id,
                        // thumb:thumb,
                        thumb:doc.data.videos[a].thumb,
                        title:doc.data.videos[a].title
                })
            }
            const object = {
                title:title,
                id:doc.id,
                date:date,
                timestamp:timestamp,
                main_thumb:main_thumb,
                description:description,
                subjects:subjects,
                duration:duration,
                parts:parts,
            }
            videos_var.push(object)
            if(index==snapshot.data.length){
                const sorted_var = videos_var.sort(((a:any,b:any)=>b.timestamp-a.timestamp))
                setVideos(sorted_var)
            }
        })
    }

    useEffect(()=>{
        if(videos.length==0){
            getVideos()
        }
    },[])
    return(
        <div style={{width:'100%'}}>
            {Object.keys(selected).length>0&&(<SelectedVideo width={props.width} video={selected}/>)}
            {Object.keys(selected).length==0&&(
            <div style={{display:'flex', justifyContent:'center', flexDirection:isMobile?'column':'row', width:'100%'}}>
                {videos.map((video:any, index:any)=>{
                    return(
                        <div key={index} style={{color:"#fff", width:isMobile?'100%':'350px', cursor:'pointer', display:'flex', justifyContent:'left', flexDirection:'column', textAlign:'left', marginRight:'20px', marginBottom:isMobile?'20px':''}} onClick={()=>{setSelected(video)}}>
                            <MainVideoThumb thumb={video.main_thumb} width={props.width}/>
                            <div style={{fontWeight:'600', fontSize:'15px', fontFamily:'Digital', color:"#ececec", marginTop:'6px'}}>
                                {video.title.toUpperCase()}
                            </div>
                            <div style={{display:'flex', alignItems:'center'}}>
                                <div style={{backgroundColor:'#333', borderRadius:'4px', display:'inline-block', width:'fitContent',padding:'1px 3px',fontSize:'10px', border:'1px solid #444', marginBottom:'3px', color:'#cdcdcd', transform:'translateY(2px)'}}>{video.date}</div>
                                <div style={{fontSize:'11px', fontWeight:'500', marginLeft:'5px', color:'#777'}}>{video.duration}</div>
                            </div>
                            <div>
                                {video.description}
                            </div>
                            <div>
                                {video.subjects.map((sub:any, index:any)=>{
                                    return(
                                        <div key={index} style={{backgroundColor:'#333', borderRadius:'4px', display:'inline-block', width:'fitContent',padding:'1px 3px',marginLeft:index>0?'3px':'', marginTop:'3px', fontSize:'10px', border:'1px solid #444', color:'#cdcdcd'}}>
                                            {sub}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                })}
            </div>)}
        </div>
    )
    
}